import { ChalkLink } from "@/components/interactive/ChalkLink";
import React from "react";
import { classNames } from "utils/classnames";
import { urlIsSameDomain } from "../../utils/link-utils";

export function NavLink({
  active,
  className,
  children,
  href,
  ...rest
}: {
  active?: boolean;
} & React.ComponentProps<"a">) {
  const link = (
    <a
      className={classNames(
        "px-1 pt-1 inline-flex items-center border-b-2 text-cds-sm font-medium",
        active
          ? "border-cds-bright-green-500 text-zinc-900 hover:border-cds-bright-green-600 hover:text-zinc-700"
          : "border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700",
        className,
      )}
      href={href}
      {...rest}
    >
      {children}
    </a>
  );

  if (href && urlIsSameDomain(href)) {
    return (
      <ChalkLink href={href} legacyBehavior unstyled>
        {link}
      </ChalkLink>
    );
  } else {
    return link;
  }
}
